import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import styles from './styles'

import { useDispatch } from 'react-redux'
import { EmbedViewHeader, EmbedView } from './components'
import { useSelector } from 'react-redux'

const EmbedTab = props => {
  const { classes, entity } = props

  const dispatch = useDispatch()

  const components = [
    {
      component: <EmbedViewHeader />,
      onView: true,
      mainPage: true,
    },
    {
      component: <EmbedView entity={entity} dispatch={dispatch} />,
      onView: true,
      mainPage: true,
    },
  ]

  return (
    <div className={classes.content}>
      <div className={classes.content__components}>
        {components.map(
          (component, index) =>
            component.onView && <div key={index}>{component.component}</div>,
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(EmbedTab)
